import { render } from "./TraitementReclamation.vue?vue&type=template&id=14ddf598&ts=true"
import script from "./TraitementReclamation.vue?vue&type=script&lang=ts"
export * from "./TraitementReclamation.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__